import React, { useEffect, useState } from 'react'
import styles from './style/banner_section_style.module.scss';
import FullWidthImage from '../../design-system/basics/full-width-image/FullWidthImage'
import BannerSlider from '../../design-system/basics/banner-slider/BannerSlider'
import Typography from '../../design-system/foundations/typography/Typography'
import Button from '../../design-system/basics/button/Button'
import Translation from '../../global/Translation'
import PnSpinner from '../PnSpinner'
import { REPO_STONES_FAMILIES } from '../NaturalStoneHelper'
import LocalizedLink from '../../global/LocalizedLink'
import { connect } from 'react-redux'

const BannerSection = ({click, ...props}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [bannerProducts, setBannerProducts] = useState(null)

    useEffect(() => {
        props.fetchBannerProducts()
    }, [])

    useEffect(() => {
        if (props.bannerProducts && props.bannerProducts.length > 0) {
            setBannerProducts(props.bannerProducts)
        }
    },[props.bannerProducts])

    useEffect(() => {
        return props.updateSection && props.updateSection(props.id, bannerProducts)
    }, [bannerProducts])

    return (
        <React.Fragment>
            {props.loadingBannerProduct && <PnSpinner className={styles['banner-section-spinner']} />}
            {bannerProducts && (
                <div id={props.id} className={styles['banner-section']}>
                    <div className={styles['slider-container']}>
                        <BannerSlider
                            setIndex={setCurrentIndex}
                            images={bannerProducts.map(p => (
                                <FullWidthImage src={p.image} />
                            ))}
                        />
                    </div>

                    <div className={styles['content-container']}>
                        <div className={styles['content-text']}>
                            <Typography block typeface="title-m-medium" accent-50>
                                {props.intl.formatMessage({id: bannerProducts[currentIndex].title_key, defaultMessage: bannerProducts[currentIndex].title})}
                            </Typography>
                            <Typography typeface="title-l-regular" accent-50>
                                {`${bannerProducts[currentIndex].colorName} - ${bannerProducts[currentIndex].brand}® - `}
                            </Typography>
                            <Typography typeface="title-l-regular" accent-50>
                                {props.intl.formatMessage({ id: REPO_STONES_FAMILIES[bannerProducts[currentIndex].family]})}
                            </Typography>
                            <Typography typeface="title-l-regular" accent-50>
                                {` ${props.intl.formatMessage({ id: bannerProducts[currentIndex].finish })} ${bannerProducts[currentIndex].thickness}cm`}
                            </Typography>
                        </div>
                        {bannerProducts[currentIndex].stock > 0 &&
                            <LocalizedLink
                                routeId="ROUTE_LOT_PRODUCT_IMAGE_VIEWER"
                                params={{
                                    parentUrl: window.location.href,
                                    productId: bannerProducts[currentIndex].productId,
                                    center: props.centerId,
                                    outlet: ''
                                }}
                                gtmLabel="ec_lupa"
                            >
                                <Button style-hero
                                        size-l
                                        onClick={() => click(bannerProducts[currentIndex], 'PN-BANNER', currentIndex )}
                                        img={props.languageDir === 'rtl' ? "arrow_short_inverse" : "arrow_short"}
                                        hImg={props.languageDir === 'rtl' ? "arrow_large_inverse" : "arrow_large"}
                                        className={styles['content-button']}
                                >
                                    <Translation id="choose_lot" defaultMessage="Choose lot" />
                                </Button>
                            </LocalizedLink>
                        }
                    </div>
                </div>
            )}
        </React.Fragment>
    )
};

const mapDispatchToProps = dispatch => {
    return {
        click: (product, list, index) => dispatch({ type: 'PRODUCT_CLICK', product, list, index})
    }
}

export default connect(null, mapDispatchToProps)(BannerSection);
